<template>
    <section class="section" id="cert" style="padding:50px 0;">
        <loading :active.sync="isLoading" :is-full-page="true" :opacity="1" background-color='#fff'></loading>
        <div class="container">
            <div class="row">
                <div class="col-md-10 offset-md-1">
                    <h1>
                        Ваш сертификат за прохождение симулятора
                    </h1>
                    <h5 style="font-weight:normal">
                        Вы можете поделиться своим сертификатом с друзьями и коллегами. Мы будем очень благодарны Вам за отзыв!
                    </h5>
                    <h6>Ссылка на Ваш публичный сертификат <a :href='"https://skillslab.center/simcert/"+id' target="_blank">https://skillslab.center/simcert/{{id}}</a></h6>
                    <h6>Поделиться в социальных сетях:</h6>
                    <twitter-button
                        :url='"https://skillslab.center/simcert/"+id'
                        description="Сертификат об уcпешном прохождении симулятора конфликтных и переговорных ситуаций Skillslab"
                    />
                    <vkontakte-button
                        :url='"https://skillslab.center/simcert/"+id'
                        title="Сертификат об уcпешном прохождении симулятора конфликтных и переговорных ситуаций Skillslab"
                    />
                    <facebook-button
                        :url='"https://skillslab.center/simcert/"+id'
                        description="Сертификат об уcпешном прохождении симулятора конфликтных и переговорных ситуаций Skillslab"
                        title="Симулятор Skillslab"
                    />
                    <div id='certificate' v-if="show">
                        <div class="cert_name">
                            {{user.last_name}}<br>{{user.first_name}}
                        </div>
                        <div class="id">https://skillslab.center/simcert/{{id}}</div>
                    </div>
                    <div id='cert_img' style="margin-top:20px;">
                        <img :src="img" alt="">
                    </div>
                </div>
                <div class="col-md-10 offset-md-1" style="margin-top:15px;">
                    <b-btn variant="primary" style="margin: 0 auto; display:block;" @click="to_home">Назад</b-btn>
                </div>
                
            </div>
            
        </div>
        
    </section>
</template>
<script>
import API from '@/api'
import * as htmlToImage from 'html-to-image';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TwitterButton from "vue-share-buttons/src/components/TwitterButton";
import VkontakteButton from "vue-share-buttons/src/components/VkontakteButton";
import FacebookButton from "vue-share-buttons/src/components/FacebookButton";
export default {
  name: "Simulator",
  data() {
    return {
        show:true, 
        user:{}, 
        id: null, 
        isLoading: true, 
        img: null
    };
  },
  components: {
      Loading, 
      TwitterButton, 
      VkontakteButton, 
      FacebookButton
  },
  mounted() {
    this.user = this.$store.getters.userData;
    
    API.get("api/my_certificates/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`
        }
      }).then(response => {
          if(response.data.length == 0)
          {
              this.$router.push("/courses");
          }
          else{

                if(!response.data[0].image)
                {

                    this.id = response.data[0].slug
                    this.wait(5000)
                    htmlToImage.toBlob(document.getElementById('certificate'))
                    .then(function (dataUrl) {
                        
                        this.img = dataUrl
                        this.img = this.img.slice(0, this.img.size, "image/png")
                        this.img = new File([this.img], this.id+'.png', { type: this.img.type })
    
                        this.show=false
                        
                        this.update_cert()
                    }.bind(this))
                    .catch(function (error) {
                        console.error('oops, something went wrong!', error);
                    });
                }
                else{
                    this.id = response.data[0].slug
                    this.show=false
                    this.img = '//api.game.skillslab.center'+response.data[0].image
                    this.isLoading = false
                }
                
          }
        
      })
      .catch(function (error) {

        if(error.response.status == 404)
        {
          this.$router.push("/courses");
        }
        if(error.response.status == 401)
        {
          this.$store.dispatch("logout");
            
        }

      }.bind(this));


    
  },
  methods: {
      wait(){
        var start = new Date().getTime();
        var end = start;
        while(end < start + 'ms') {
            end = new Date().getTime();
        }
      },
      to_home()
      {
          this.$router.push('/cources')
      },
      update_cert() {
        const data = new FormData();
        const config = {
            headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${this.$store.state.token}` }
        };
        data.append("image", this.img);
        API.post("api/set_cert_image/"+this.id+"/", data, config).then(response => {
            this.img = response.data.image.replace(/^http:\/\//i, 'https://')
            this.isLoading = false
        })
    },
  },
};
</script>
<style>
.cert_name
{
    font-size: 50px;
    line-height: 1.2;
    color: #8cc9d6;
    font-weight: 700;
    position: absolute;
    top: 0;
    left: 22.6%;
    top: 19.5%;
}
#certificate
{
    position: relative;
    display: block;
    width: 1000px;
    height: 683px;
    background-image: url('../assets/cert.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: left top;
    border: 3px #8cc9d6 solid;
    
}
#cert_img img{
    width: 100%;
    max-width: 900px;
}
.id
{
    position: absolute;
    font-size: 13px;
    bottom: 1%;
    left: 1%;
    opacity: .6;
}
</style>
